import { motion } from 'framer-motion'
import styled from 'styled-components'
import { mobileL } from '../../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const CardWrapper = styled(motion.div)`
  position: relative;
  padding-bottom: 100px;
  color: black;
  max-height: 600px;
  max-width: 736px;
  border-radius: 16px;

  ${mobileL({
    minHeight: '100vh',
    margin: '0 !important',
    paddingBottom: '890px !important',
    borderRadius: '0 !important',
  })};

  .job-description {
    ${mobileL({
      display: 'flex',
      flexDirection: 'column',
    })};
  }

  .jobname {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    color: #0d205f;
  }

  .job-info-title {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #2b3e7c;
    ${mobileL({
      width: '100%',
    })};
  }

  .company-infos-card {
    color: #0d205f;

    // responsive for mobile
  }

  .jobname {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 48px;
  }

  .description {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  h2 {
    color: #0d205f;
    font-size: 25px;
    margin-bottom: 0;
  }

  h3 {
    color: #326bd0;
    font-size: 18px;
    font-weight: 600;
  }

  .like-desc {
    display: none;
    font-size: 10px;
    color: #fff;
    background-color: #ff5722;
    padding: 9px;
    border-radius: 14px;
    transition: all ease 600ms;
  }

  .card__header {
    ${mobileL({
      borderRadius: '0 !important',
    })};
  }

  .card-body {
    padding: 1.5rem 3rem;

    ${mobileL({
      padding: '1rem',
    })};
  }

  .card-description-title {
    padding-top: 1rem;
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 32px;
    color: #2b3e7c;
  }

  .card-description {
    max-height: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .card-description::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;

    background: linear-gradient(
      180deg,
      transparent 0%,
      transparent 60%,
      white 80%
    );
    filter: blur(4px);
  }

  .see-more-button {
    position: absolute;
    top: 475px;
    right: 50px;

    ${mobileL({
      top: '640px',
      right: '10px',
    })};
  }

  @media (min-width: 768px) {
    .company-infos-card {
      left: unset;
    }

    .like-desc {
      display: inline;
    }
  }
`
